export default __webpack_public_path__ + "static/N0157-0edc8437fd58add251e03e538618fb3e.png";